import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import colors from 'styles/colors'
import ShareResultPopupButton from 'components/molecules/assessments/ShareResultPopupButton'
import RadarGraphLegend from 'components/atoms/RadarGraphLegend'
import RadarGraphNew from './RadarGraphNew'
import ShareIcon from '@mui/icons-material/Share'
import { IconContainer } from 'components/atoms/Icons'

const AssessmentGraph = ({ timelineData }) => {
  const { t } = useTranslation()

  return (
    <>
      <ShareResultPopupButton
        assessmentId={timelineData.id}
        title={t('shareMyResults.heading')}
        buttonLabel={t('shareMyResults.shareResults')}
        inverseTheme={true}
        endIcon={<IconContainer icon={<ShareIcon />} />}
        sx={{
          position: 'absolute',
          top: 0,
          right: 24,
          '&:hover': {
            '& svg': {
              fill: colors.White
            }
          }
        }}
      />

      <RadarGraphNew
        assessmentData={timelineData}
        showScoreLabel={true}
        styles={{ marginRight: 70 }}
      />

      <Box
        sx={{ position: 'absolute', bottom: 0, right: 24 }}
        position={'absolute'}>
        <RadarGraphLegend
          displayOthersRating={timelineData.othersAllBehaviourAvg > 0}
          colStyle={true}
        />
      </Box>
    </>
  )
}
export default AssessmentGraph
